import { Icon } from '@y42/core/icon';
import { bigQueryIcon, snowflakeIcon } from '@y42/icons';

export enum DatabaseType {
  BigQuery = 'BigQuery',
  Snowflake = 'Snowflake',
}

export const DatabaseTypeToLabel: Record<DatabaseType, string> = {
  [DatabaseType.BigQuery]: 'BigQuery',
  [DatabaseType.Snowflake]: 'Snowflake',
};

export const DatabaseTypeToLogo: Record<DatabaseType, Icon> = {
  [DatabaseType.BigQuery]: bigQueryIcon,
  [DatabaseType.Snowflake]: snowflakeIcon,
};
